export default __webpack_public_path__ + "static/ce681b97dacdad692e8996441c449a65.png";